import { Button } from 'flowbite-react';
import React from 'react'
interface PaymentLinkDetailsProps {
    paymentLink: any;
    close:()=> void
}
const PaymentLinkDetails = ({ paymentLink, close }: PaymentLinkDetailsProps) => {
    const handleInitiatePayment = (link:string)=>{
        window.open(link, '_blank')
    }
    return (
        <div className="max-w-lg mx-auto p-6 bg-white">
            <div className="flex items-center mb-4">
                <div className="flex-grow">
                    <h2 className="text-lg font-bold text-gray-900">{paymentLink.name}</h2>
                    <p className="text-sm text-gray-500">Link type - {paymentLink.paymentType}</p>
                </div>
            </div>

            <div className="">
                <div className='grid grid-cols-2 my-2'>
                    <p className="font-medium text-sm">Amount</p>
                    <p className="text-gray-600 text-sm">{paymentLink.amount ? `${paymentLink.currency} ${paymentLink.amount}` : "Any Amount"}</p>
                </div>
                <div className='grid grid-cols-2 my-2'>
                    <p className="font-medium text-sm">Currency</p>
                    <p className="text-gray-600 text-sm">{paymentLink.currency}</p>
                </div>
                <div className="grid grid-cols-2 my-2">
                    <p className="font-medium text-sm">Created By</p>
                    <p className="text-gray-600 text-sm break-all">{paymentLink.createdBy}</p>
                </div>
                <div className="grid grid-cols-2 my-2">
                    <p className="font-medium text-sm">Reference</p>
                    <p className="text-gray-600 text-sm break-all">{paymentLink.reference}</p>
                </div>
                <div className='flex items-center grid grid-cols-2 my-2'>
                    <p className="font-medium text-sm">Status</p>
                    <span className={`inline-block px-3 py-1 text-sm text-center font-semibold rounded-full ${paymentLink.isActive ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
                        {paymentLink.isActive ? "Active" : "Inactive"}
                    </span>
                </div>
            </div>

            <div className="flex justify-center gap-3 mt-4">
                <Button onClick={()=>close()} className='rounded-sm bg-white text-black hover:text-white  border-2 border-gray-300 hover:bg-gray-100'>Close</Button>

                <Button className='rounded-sm bg-custom-button-green' onClick={()=>handleInitiatePayment(paymentLink.paymentLinkUrl)}>Initiate Payment</Button>
            </div>
        </div>
    );
};

export default PaymentLinkDetails;

